import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class PdfManagerService {

  currentPdf;
  viaApp = false;
  
  constructor(private http: HttpClient) { }

  validatePdfGuideToken(url){
    //this.loading = true;
    return this.http.get(url);
  }

  enableAccessToPdf(){
    this.viaApp = true;
  }

  isLinkValid(){
    return this.viaApp;
  }

  downloadPDF(url: string, filename: string): void {
    const headers = new HttpHeaders().set('Content-Type', 'application/pdf');
    this.http.get(url, { headers, responseType: 'blob' })
      .subscribe(blob => {
        saveAs(blob, filename);
      });
  }

  downloadPdf(): void {
    // Call service to download
/*     let pdfUrl = this.pdfManager.getPdfToDownload(this.pdfManager.getCurrentPdfId());
    const pdfName = this.pdfManager.getPdfName(this.pdfManager.getCurrentPdfId());
    this.pdfManager.downloadPDF(pdfUrl, pdfName); */
  }

  downloadPdf2(url){
    //window.open('../../../assets/voyjaleas/pdf/empadronamiento/hojaPadronal.pdf', '_blank');
    /* var link = document.createElement('a');
    link.href = 'assets/voyjaleas/pdf/empadronamiento/hojaPadronal.pdf';
    link.download = 'file.pdf';
    link.dispatchEvent(new MouseEvent('click')); */
  }

  downloadAnyPdf(url: string) {
    this.http.get(url, { responseType: 'blob' }).subscribe(blob => {
      const filename = `guia_estudios_espana.pdf`; // Cambiá el nombre si es necesario
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
    }, error => {
      console.error('❌ Error al descargar el PDF:', error);
      //this.showError?.(); // opcional si tenés una función de error
    });
  }

  getPdfToDownload(pdfId){
    this.currentPdf = pdfId;
    switch(pdfId){
      case 'mapaMetroMadrid':
        return 'assets/voyjaleas/pdf/transport/metro/mapaMetroMadrid.pdf';
      case 'mapaMetroBarcelona':
        return 'assets/voyjaleas/pdf/transport/metro/mapaMetroBarcelona.pdf';
      case 'mapaMetroValencia':
        return 'assets/voyjaleas/pdf/transport/metro/mapaMetroValencia.pdf';
      // ACCOMMODATION
      case 'guiaMadridHospedaje':
        return 'assets/voyjaleas/pdf/accommodation/FREE_Hospedaje_Madrid_Larga_Duracion.pdf';
      case 'guiaAltaPadron':
        return 'assets/voyjaleas/pdf/empadronamiento/guiaAltaPadronMadrid.pdf';
      case 'hojaPadronal':
        return 'assets/voyjaleas/pdf/empadronamiento/hojaPadronal.pdf';
      case 'condicionesSeguro':
        return 'assets/voyjaleas/pdf/health/condicionesAsisa.pdf';
      case 'formularioVisado':
        return 'assets/voyjaleas/pdf/visa/FORMULARIO_SOLICITUD_VISADO.pdf';
      case 'formularioAsisa':
        return 'assets/voyjaleas/pdf/health/Formulario-Solicitud_ASISA.pdf';
      case 'cuestionarioAsisa':
        return 'assets/voyjaleas/pdf/health/Cuestionario-de-Salud_ASISA.pdf';
      default:
        break;
    }
  }

    
  getPdfName(pdfId){
    this.currentPdf = pdfId;
    switch(pdfId){
      case 'mapaMetroMadrid':
        return 'mapaMetroMadrid.pdf';
      case 'mapaMetroBarcelona':
        return 'mapaMetroBarcelona.pdf';
      case 'mapaMetroValencia':
        return 'mapaMetroValencia.pdf';
      // ACCOMMODATION
      case 'guiaMadridHospedaje':
        return 'FREE_Hospedaje_Madrid_Larga_Duracion.pdf';
      case 'hojaPadronal':
        return 'hojaPadronal.pdf';
      case 'guiaAltaPadron':
          return 'guiaAltaPadron.pdf';
      case 'condicionesSeguro':
        return 'condicionesSeguroMedicoAsisa.pdf';
      case 'formularioVisado':
        return 'formularioSolicitudVisado.pdf';
      case 'formularioAsisa':
          return 'Formulario-Solicitud_ASISA.pdf';
      case 'cuestionarioAsisa':
        return 'Cuestionario-de-Salud_ASISA.pdf';
      default:
        return 'voyjaleas_pdf;'
    }
  }

  getCurrentPdfId(){
    return this.currentPdf;
  }

  setCurrentPdfId(pdf){
    this.currentPdf = pdf;
  }
}
